export default class TaskCardController {
  constructor(Task, $state) {
    'ngInject';

    this.$state = $state;
    this.Task = Task;
  }

  handleAccept(task) {
    this.Task.accept({}, task).$promise.then(() => {
      this.$state.go('engineer.tasks.task-detail.info', {taskId: task.id});
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/task-card/task-card.controller.js